const VOUCHER_REASON_TYPE = Object.freeze({
  created: 'created',
  used: 'used',
  void: 'void',
});

// noinspection JSUnusedGlobalSymbols
export default VOUCHER_REASON_TYPE;
